import request from 'yeself-common/utils/RequestUtils';
import { ApplicationId } from 'yeself-common/typings/application/Application';
import { RepositoryIdValue } from 'yeself-common/typings/addons/assetAddon/AssetAddonCommon';
import { AddonSystemKeyValue, AssetId } from 'yeself-common/typings/guide/recording/Recording';
import { LayerId } from 'yeself-common/typings/guide/LayerCommon';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const downloadRecordingOutputsRequest = (
    applicationId: ApplicationId,
    addonSystemKey: AddonSystemKeyValue,
    repositoryId: RepositoryIdValue,
    assetId: AssetId
) =>
    request.get(
        `${EnvironmentConfiguration.API_ADDON_MODULES_SLUG}/asset--download/addons/${addonSystemKey}/manage/applications/${applicationId}/repository/${repositoryId}/asset/${assetId}`,
        { responseType: 'blob' }
    );

export const generateRecordingOutputsRequest = (applicationId: ApplicationId, recordingId: LayerId) =>
    request.post(
        `${EnvironmentConfiguration.API_ADDON_MODULES_SLUG}/recording--generate/addons/yeself-addon-recording/manage/applications/${applicationId}/recordings/${recordingId}/generate`,
        {}
    );
